import { ViewIcon, NotVisibleIcon } from "../../../../../../assets/icons/shared"
import { useState } from "react"

import type { TextFieldProps } from "../.."

import styles from "../../index.module.css"
import { BaseField, IconWrapper } from "../baseField"

export const PasswordField = ({ label, errorText, iconLeft, ...inputProps }: TextFieldProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev)
  }

  return (
    <BaseField
      label={label}
      errorText={errorText}
      required={inputProps.required}
      disabled={inputProps.disabled}
      id={inputProps.id}
    >
      {iconLeft && <IconWrapper position="left">{iconLeft}</IconWrapper>}
      <input {...inputProps} type={isVisible ? "text" : "password"} className={styles.input} />
      <IconWrapper position="right">
        <button
          type="button"
          onClick={toggleVisibility}
          className={styles.iconButton}
          aria-label={isVisible ? "Hide password" : "Show password"}
        >
          {isVisible ? <NotVisibleIcon /> : <ViewIcon />}
        </button>
      </IconWrapper>
    </BaseField>
  )
}
